exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".delegated-card-row{display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;width:100%;padding:15px 0;border-bottom:1px solid #eaebed}.delegated-card-row .section-row{flex:1}.delegated-card-row .section-row:nth-of-type(2){flex:3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/delegatedCardRow.scss
// module id = 1706
// module chunks = 0